import clsx from 'clsx';

import type * as api from '@gitbook/api-client';
import type { Plugin } from '@gitbook/slate-react';

import { BasicDocument } from '../BasicEditor';

/**
 * The text of a message, from either side: the agent's answer, or what the user sent — a plain
 * string from a suggestion or a starter, or the document the composer produced.
 */
export function MessageDocument(props: {
    content: string | api.JSONDocument;
    className?: string;
    /** @default 'text-ui-base' */
    typographyClassName?: string;
    plugins?: Plugin[];
}) {
    const { content, className, typographyClassName = 'text-ui-base', plugins } = props;

    if (typeof content === 'string') {
        return (
            <div
                className={clsx(
                    'wrap-anywhere whitespace-pre-wrap',
                    typographyClassName,
                    className
                )}
            >
                {content}
            </div>
        );
    }

    return (
        <BasicDocument
            document={content}
            className={clsx('wrap-anywhere', className)}
            typographyClassName={typographyClassName}
            plugins={plugins}
        />
    );
}
